'use es6';

import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ShareIcons from './ShareIcons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ShareBanner extends Component {
  render() {
    return /*#__PURE__*/_jsx("div", {
      className: "share-banner",
      children: /*#__PURE__*/_jsxs("div", {
        className: "share-banner-content",
        children: [/*#__PURE__*/_jsxs("span", {
          className: "share-banner-header",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "results.share.banner.title"
          }), /*#__PURE__*/_jsx("span", {
            className: "share-banner-paragraph p-left-2",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "results.share.banner.description"
            })
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "share-banner-buttons",
          children: /*#__PURE__*/_jsx(ShareIcons, {
            websiteUrl: this.props.websiteUrl
          })
        })]
      })
    });
  }
}
export default ShareBanner;